"use client";

import Image from "next/image";
import Link from "next/link";
import { getProductPath } from "@/lib/productPaths";

export default function ProductCard({ product }) {
  const lowestPrice = (product.options?.forms ?? [])
    .flatMap(form => form.strengths ?? [])
    .flatMap(strength => strength.counts ?? [])
    .reduce((min, c) => (c.price < min ? c.price : min), Infinity);

  return (
    <Link
      href={getProductPath(product)}
      className="group flex flex-col bg-white rounded-2xl overflow-hidden border border-slate-200 hover:border-emerald-200 shadow-sm hover:shadow-md transition-all duration-300 hover:-translate-y-1"
    >
      {/* Image with description overlay */}
      <div className="relative w-full aspect-square overflow-hidden bg-slate-50">
        <Image
          src={`/images/products/${product.image}`}
          alt={product.name}
          fill
          className="object-contain p-3 group-hover:scale-105 transition-transform duration-300"
        />
        <div className="absolute inset-0 bg-emerald-950/0 group-hover:bg-emerald-950/80 flex items-center justify-center transition-all duration-300 p-4">
          <p className="text-white text-sm font-medium leading-relaxed text-center opacity-0 group-hover:opacity-100 transition-opacity duration-300">
            {product.description}
          </p>
        </div>
      </div>

      {/* Card body */}
      <div className="flex flex-col flex-1 p-4 gap-3">
        <h3 className="text-sm font-semibold text-slate-800 leading-snug group-hover:text-emerald-700 transition-colors">
          {product.name}
        </h3>

        <div className="flex items-center justify-between mt-auto pt-3 border-t border-slate-100">
          <span className="text-xs text-slate-400">
            as low as{" "}
            <span className="text-emerald-700 font-bold text-sm">${lowestPrice.toFixed(2)}</span>
          </span>
          <span className="text-xs font-semibold text-white bg-slate-700 group-hover:bg-emerald-700 px-3 py-1.5 rounded-lg transition-colors">
            View →
          </span>
        </div>
      </div>
    </Link>
  );
}
